<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Certificado de anotaciones</h1>
                <button
                    mat-flat-button class="custom-button-primary no-print"
                    [printTitle]='"CertificadoAnotaciones_"+(rut | rutFormat)+"_"+today'
                    [useExistingCss]="true"
                    printSectionId="print-section" ngxPrint>
                        <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app" class="icon-download"></mat-icon>
                        Descargar Resultado
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut">
                        <strong>RUT:</strong> {{datosBasicosSolicitud.Rut | number:'1.0-0'}}-{{datosBasicosSolicitud.DV | uppercase}}</mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12">
                <mat-card class="mt-5">
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Certificado de anotaciones</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-500">Rut empresa:</div>
                                <div>{{ content.RutSociedad | rutFormat }}</div>

                                <div class="font-weight-500">Razón social:</div>
                                <div>{{ content.RazonSocial }}</div>

                                <div class="font-weight-500">Fecha constitución:</div>
                                <div>{{ content.FechaConstitucion }}</div>

                                <div class="font-weight-500">Fecha del certificado:</div>
                                <div>{{ content.FechaEmisionCertificado }}</div>

                                <div class="font-weight-500">Anotaciones:</div>
                                <div>{{ content.Declaracion }}</div>

                                <div class="font-weight-500">CVE:</div>
                                <div>{{ content.CodigoVerificacion }}</div>
                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>
